// extracted by css-extract-rspack-plugin
module.exports =  {"file-url":"Source3-rQCX__file-url","file-label":"Source3-XtIw__file-label","file-icon":"Source3-ebWA__file-icon","not-found":"Source3-FzUV__not-found"};